export const IngredientTypes = {
  BUN: "bun",
  SAUCE: "sauce",
  MAIN: "main",
};
